import Vue from 'vue'
import Router from "vue-router";
import Body from '../components/body';
import Auth from '../auth/auth';
import LandingPage from '../auth/landing-page';
import UserEditProfile from '../pages/Users/edit-profile';
import Profile from '../pages/Users/profile';
import Trac from '../pages/trac-builder/trac-page';
import UserTrac from '../pages/user-trac/user-trac';
import TracView from '../pages/trac-builder/trac-view';
import UserTracDetails from '../pages/user-trac/user-trac-details';
import Upgrade from '../pages/upgrade';
import ConfirmPayment from '../pages/confirmPayment';
import Reporting from '../pages/reporting';
import Categories from '../pages/categories';

/* Auth */
import login from '../auth/login'
import Register from '../auth/register';
import forgotPassword from '../auth/forgot-password';
import resetPassword from '../auth/reset-password';
import ConfirmEmail from '../auth/confirm-email';
import Userauth from '../auth/js/index';
import { store } from '../store';

/* sample page */
import Dashboard from '../pages/dashboard'

// component

Vue.use(Router);

const routes = [
    {path: '', redirect: {name: 'default'}},
    {
        path: '/auth',
        component: Auth,
        children: [
            {
                path: 'login',
                name: 'login',
                component: login,
                meta: {
                    title: ' Login | ONTrac ',
                }
            },
            {
                path: 'forgot-password',
                name: 'forgot-password',
                component: forgotPassword,
                meta: {
                    title: ' Forgot Password | ONTrac ',
                }
            },
            {
                path: 'reset-password',
                name: 'reset-password',
                component: resetPassword,
                meta: {
                    title: ' Reset Password | ONTrac ',
                }
            },
            {
                path: 'register',
                name: 'register',
                component: Register,
                meta: {
                    title: ' Sign Up | ONTrac ',
                }
            }
        ]
    },
    {
        path: '/dashboard',
        component: Body,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: 'default',
                name: 'default',
                component: Dashboard,
                meta: {
                    title: ' Partner Dashboard | ONTrac ',
                }
            },
            {
                path: 'trac',
                name: 'trac',
                component: Trac,
                meta: {
                    title: ' Partner Dashboard | ONTrac ',
                }
            },
            {
                path: 'trac/:id',
                name: 'trac-view',
                component: TracView,
                props: true,
                meta: {
                    title: ' SMARTracs | ONTrac ',
                }
            },
            {
                path: 'user-trac/:id',
                name: 'user-trac',
                component: UserTrac,
                props: true,
                meta: {
                    title: ' User Trac | ONTrac ',
                }
            },
            {
                path: 'user-tracs/:tracId/:clientId',
                name: 'user-tracs',
                component: UserTracDetails,
                props: true,
                meta: {
                    title: ' User Tracs | ONTrac ',
                }
            },
            {
                path: 'reporting',
                name: 'reporting',
                component: Reporting,
                props: true,
                meta: {
                    title: ' Reporting SMARTracs | ONTrac ',
                }
            },
            {
                path: 'categories',
                name: 'categories',
                component: Categories,
                props: true,
                meta: {
                    title: ' Categories SMARTracs | ONTrac ',
                },
                beforeEnter: (to, from, next) => {
                    const user = JSON.parse(localStorage.getItem('userinfo'));
                    const roles = user.roles ? user.roles.concat(store.state.userRoles) : store.state.userRoles;
                    
                    if (roles && roles.includes('Administrator')) {
                        next();
                    }
                    
                    if (roles && roles.includes('Advisor')) {
                        next();
                    }

                    next(false);
                }
            },
        ]
    },
    {
        path: '/users',
        component: Body,
        children: [
            {
                path: 'edit',
                name: 'UserEditProfile',
                component: UserEditProfile,
                meta: {
                    title: 'Profile Edit | ONTrac',
                }
            }
        ]
    },
    {
        path: '/referral/:code',
        name: 'referral',
        component: LandingPage,
        props: true
    },
    {
        path: '/profile/:url',
        name: 'profile',
        component: Profile,
        props: true
    },
    {
        path: '/confirm-email',
        name: 'confirm-email',
        component: ConfirmEmail,
    },
    {
        path: '/upgrade',
        name: 'upgrade',
        component: Upgrade,
    },
    {
        path: '/tier-change/:uid',
        props: true,
        component: ConfirmPayment,
        meta: {
            requiresAuth: true
        },
    }
];


const router = new Router({
    routes,
    base: '/',
    mode: 'history',
    linkActiveClass: "active",
    scrollBehavior() {
        return {x: 0, y: 0}
    }
});

router.beforeEach((to, from, next) => {
    if (to.meta.title)
        document.title = to.meta.title;
    const path = [
        '/auth/login',
        '/auth/register',
        '/confirm-email',
        '/auth/forgot-password'
    ];
    if (path.includes(to.path) || to.path === "/callback" || to.name === "reset-password" || Userauth.isAuthenticatedUser()) {
        return next();
    }
    next('/auth/login')
});

export default router
